import {css} from "@emotion/react";

export const selectStyle = css`
    width: 200px;
    border-radius: 4px !important;
    border-color: #a9a9a9 !important;
    outline: none;
`;

export const phoneStyle = css`
    width: 200px;
    height: 35px;
    font-size: 14px;
    border-radius: 4px !important;
    border-color: #a9a9a9 !important;
    outline: none;
`;
